export const MQ_DESKTOP_MIN_WIDTH = 1101;
export const MQ_TABLET_MAX_WIDTH = MQ_DESKTOP_MIN_WIDTH - 1;
export const MQ_TABLET_MIN_WIDTH = 701;
export const MQ_MOBILE_MAX_WIDTH = MQ_TABLET_MIN_WIDTH - 1;
export const MQ_MOBILE_MIN_WIDTH = 480;
export const MQ_SMALL_MOBILE_MAX_WIDTH = MQ_MOBILE_MIN_WIDTH - 1;
export const ROOM = 'rooms';
export const APARTMENT = 'apartments';
export const RESIDENCE = 'residences';
export const STUDENTS = 'studios';
export const ROOM_TYPES = [ROOM, APARTMENT, RESIDENCE, STUDENTS];
export const HI_JIFFY_TOKEN = '6aDaya1CgnMlhg';

export const HOMECARD_IMAGE_SIZES = {
  homecardHidpi: '640w',
  homecard: '320w'
};

export default {
  MQ_DESKTOP_MIN_WIDTH,
  MQ_TABLET_MAX_WIDTH,
  MQ_TABLET_MIN_WIDTH,
  MQ_MOBILE_MAX_WIDTH,
  MQ_MOBILE_MIN_WIDTH,
  MQ_SMALL_MOBILE_MAX_WIDTH,
  HOMECARD_IMAGE_SIZES,
  ROOM,
  APARTMENT,
  RESIDENCE,
  STUDENTS,
  ROOM_TYPES,
  HI_JIFFY_TOKEN
};
